






























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import Info from '@/views/AiiTasks/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import Task from '@/web-task'
import AgreementSec from '@/views/mediate/agreement.vue'
import MediateCost from '@/views/mediate/mediateCost.vue'
import MediateCostTable from '@/views/mediate/mediateCostTable.vue'
import NeedDocument from '@/views/mediate/needDocument.vue'
import MediateApi from '@/api/mediate'
import { hasValue } from '@/utils/util'
import { taskRequest } from '@/utils/regExp'

@Component({
	components: {
		Info,
		InfoRow,
		AgreementSec,
		MediateCost,
		NeedDocument,
		MediateCostTable,
	},
})
export default class MediateInfo extends Vue {
	private mediateForm: any = {}
	// 已设置金额的费用项
	private injuredCostArr: any = []
	private noConciliationMap: any = {}
	private creating: boolean = false
	private taskInfo: any = {}
	private carOwnerInfo: any = {}
	private injuredInfo: any = {}
	private agreementsInfo: any = {}
	private costTableInfo: any = {}
	private caseDelayInfo: any = {}
	private isOtherMediate = false
	public taskRequest: any = taskRequest

	@Prop()
	private noMediateIndex!: any

	@Prop()
	private supplyInfo!: any

	@Prop()
	private injured!: any

	@Prop()
	private task!: any

	@Prop()
	private order!: any

	// 设置金额状态
	private get mediateSetCost() {
		return this.order.orderStatus === '04' && this.order.auditOperationTime
	}

	private get firstMediateInjured() {
		return this.injuredInfo.findIndex((item: any, index: number) => {
			return !this.noMediateIndex.includes(index)
		})
	}

	// 任务要求变为可输入项
	private get mediateTaskInfo() {
		let temp = cloneDeep(this.taskInfo)
		let removeItems = ['车主姓名', '车主电话', '任务要求']
		if (temp && temp.children) {
			removeItems.forEach((removeItem: string) => {
				let index = temp.children.findIndex((item: any) => {
					return removeItems.includes(item.label)
				})
				temp.children.splice(index, 1)
			})
		}
		// 确定需要调解后，展示是否需收集资料
		if (this.task.isLastHalfMediate) {
			temp.children.push(
				{
					label: '任务要求',
					value: this.order.conciliationRequire,
				},
				{
					label: '是否需要收集材料',
					value: this.task.setting.yesNoMap[this.order.collected],
				}
			)
			if (this.order.collected === '1') {
				temp.children.push(
					{
						label: '收集材料',
						value: this.order.collectData,
					},
					{
						label: '邮寄地址',
						value: this.order.mailAddress,
					},
					{
						label: '收件人',
						value: this.order.mailReceivor,
					},
					{
						label: '收件人电话',
						value: this.order.mailReceivorPhone,
					}
				)
			}
		}
		return temp
	}

	@Watch('task', { immediate: true })
	private onTaskChange() {
		// task为{}，非Task对象时不调用属性方法
		if (!(this.task instanceof Task)) {
			return
		}

		this.taskInfo = this.task.getTaskInfo()
		this.carOwnerInfo = this.task.getMediateCarOwner()
		this.injuredInfo = this.task.getMediateInjured()
		this.agreementsInfo = this.task.getAgreementsInfo()
		this.costTableInfo = this.task.getCostTableInfo()
		this.isOtherMediate = this.task.isOtherMediate
		this.caseDelayInfo = this.task.getCaseDelayInfo()
	}

	private onConciliationChange(evt: any, index: number) {
		this.noConciliationMap[index] = evt.target.checked
		this.noConciliationMap = { ...this.noConciliationMap }
	}

	// 发起调解
	private createConciliation() {
		this.mediateForm.validateFields((err: any, values: any) => {
			if (!err) {
				let data = cloneDeep(values),
					atLeastOne = false,
					notSetIndex = -1
				const fields = [
					'medicalFee',
					'furtherMedicalFee',
					'mealsFee',
					'compensation',
					'caregiversFee',
					'commuteFee',
					'otherFee',
				]
				data.fees.forEach((item: any, index: number) => {
					item.injuredId = this.injuredInfo[index].injuredId
					item.conciliationStatus = item.noConciliation ? '0' : '1'
					atLeastOne = atLeastOne || !item.noConciliation
					const some = fields.some((key: any) => {
						return hasValue(item[key])
					})

					if (!item.noConciliation && !some && notSetIndex < 0) {
						notSetIndex = index
					}
				})

				if (!atLeastOne) {
					this.$message.error(
						'最少需要一个伤者需要调解，如果该任务无需调解，需要点击按钮无需调解即可'
					)
					return
				}
				// 至少需填写一项费用
				if (notSetIndex >= 0) {
					this.$message.error(
						`请填写需要赔付给${this.injuredInfo[notSetIndex].injuredName}的对应的费用，最少填写一项`
					)
					return
				}
				this.creating = true
				MediateApi.createConciliation(this.$route.params.orderId, '1', data)
					.then((res: any) => {
						this.$emit('getDetail')
					})
					.finally(() => {
						this.creating = false
					})
			}
		})
	}

	private setNoMediate(index: number) {}

	private onCostChange(payload: any) {
		this.injuredCostArr[payload.index] = payload
		this.injuredCostArr = [...this.injuredCostArr]
	}

	private created() {
		this.mediateForm = this.$form.createForm(this)
	}
}
